module.exports = __webpack_public_path__ + "static/media/mc_open_vector.cc6e71e8.svg";